import { PROPERTY_EMPTY_IMAGE } from '../constants';

import { pickImagesFromEstate } from './pickImagesFromEstate';

import type { StrapiEstate } from '@monoimin/sb-types';

/**
 * Подготовка изображения объекта недвижимости (single image field) для использования.
 *
 * @param estate - Данные объекта недвижимости.
 * @returns Подготовленый для использования в изображениях объект.
 */
export const pickMainImageFromEstate = (estate?: StrapiEstate) => {
  if (!estate) {
    return PROPERTY_EMPTY_IMAGE;
  }

  const pickedImages = pickImagesFromEstate(estate);

  if (pickedImages.length) {
    return pickedImages[0];
  }

  return PROPERTY_EMPTY_IMAGE;
};

export default pickMainImageFromEstate;
